__webpack_require__.p = "/rock-paper-scissors/";